var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import classNames from "classnames";
import { Icon } from "../Icon";
// styles
import "./spinner.scss";
// use the optional prop interface to define the default props
const defaultProps = {
    size: "medium",
    "data-testid": "tecma-spinner",
    type: "circle",
};
const Spinner = (_a) => {
    var { size, gradient, type, className } = _a, rest = __rest(_a, ["size", "gradient", "type", "className"]);
    const classList = classNames("tecma-spinner", { [`${size}`]: size }, { gradient }, { [`${type}`]: type }, className);
    return (_jsxs(_Fragment, { children: [type === "circle" && _jsx("div", Object.assign({ className: classList }, rest)), type === "dotted" && (_jsxs("div", Object.assign({ className: classList }, rest, { children: [_jsx("div", { className: "dot" }), _jsx("div", { className: "dot" }), _jsx("div", { className: "dot" })] }))), type === "dotted-circle" && (_jsx(Icon, Object.assign({ className: classList }, rest, { iconName: "dotted-circle", size: size })))] }));
};
Spinner.defaultProps = defaultProps;
export default React.memo(Spinner);
